import React from "react";
import logo from "../assets/logo.svg";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <img className="mb-3 app-logo" src={logo} alt="React logo" width="50" />
    <p>
     FYP by Suhaib, Taha and Usama <a href="https://signulation.com">Signulation</a>
    </p>
  </footer>
);

export default Footer;
